import { render, staticRenderFns } from "./productDesc.vue?vue&type=template&id=38c01805&scoped=true&"
import script from "./productDesc.vue?vue&type=script&lang=js&"
export * from "./productDesc.vue?vue&type=script&lang=js&"
import style0 from "./productDesc.vue?vue&type=style&index=0&lang=css&"
import style1 from "./productDesc.vue?vue&type=style&index=1&id=38c01805&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c01805",
  null
  
)

export default component.exports